import { render, staticRenderFns } from "./pagos.vue?vue&type=template&id=14f8df72"
import script from "./pagos.vue?vue&type=script&lang=js"
export * from "./pagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports